


































































































import Context from "@/mixins/context";
import {
  IAvailableTermMapped,
  IProductConfigProviderData
} from "@/models/providers/products";
import { Component, Prop, Inject, Mixins } from "vue-property-decorator";
import {
  BrandConfigKeys,
  PriceBeforeDiscountPositions
} from "@/data/constants";

@Component({
  components: {
    "editable-price": () =>
      import(
        "@/components/app/global/baskets/basket/productView/editablePrice.vue"
      )
  }
})
export default class ProductTermCard extends Mixins(Context) {
  // Inject

  @Inject({ from: "productConfigProviderData" })
  public readonly productConfigProviderData!: () => IProductConfigProviderData;

  // Props

  @Prop({ required: true })
  public readonly term!: IAvailableTermMapped;

  @Prop({ default: false })
  public readonly disabled!: boolean;

  @Prop({ default: false })
  public readonly hasError!: boolean;

  // Computed

  public get $product() {
    return this.productConfigProviderData();
  }

  public get showWasPriceAfter() {
    return (
      this.$store.getters["brand/config"][
        BrandConfigKeys.UI_PRICE_BEFORE_DISCOUNT_POSITION
      ] === PriceBeforeDiscountPositions.AFTER
    );
  }

  public onInput() {
    if (this.disabled) return;
    this.$emit("input", this.term.months);
  }
}
